<form [formGroup]="form">
    <div class="card">
        <div class="card-header">
            <div class="title-4">Dati anagrafici</div>
        </div>
        <div class="card-body">
            <div class="group-inline pt-5" style="align-items: center;">
                <div class="form-group" style="margin-bottom: 0;">
                    <div class="inRowDispositionRadio form-check-inline">
                        <label for="genere" class="noMarginBottom">Maschio</label>
                        <input type="radio" [ngClass]="{'border-red-radio': invalidBorder('sesso') == true}"
                            class="form-check-input" value="M" id="genere" formControlName="sesso">
                    </div>
                    <div class="inRowDispositionRadio form-check-inline">
                        <label for="genere" class="noMarginBottom">Femmina</label>
                        <input type="radio" [ngClass]="{'border-red-radio': invalidBorder('sesso') == true}"
                            class="form-check-input" value="F" id="genere" formControlName="sesso">
                    </div>
                </div>
                <div class="form-group field-30">
                    <label for="nome">Nome *</label>
                    <input type="text" class="form-control field-height-40"
                        [ngClass]="{'border-danger': invalidBorder('nome') == true}" id="nome" formControlName="nome">
                </div>
                <div class="form-group field-30">
                    <label for="cognome">Cognome *</label>
                    <input type="text" class="form-control field-height-40"
                        [ngClass]="{'border-danger': invalidBorder('cognome') == true}" id="cognome"
                        formControlName="cognome">
                </div>
                <div>
                    <div class="form-group field-28">
                        <div class="inRow" style="justify-content: space-between;">
                            <label for="codiceFiscale">Codice fiscale *</label>
                            <label *ngIf="form.get('codiceFiscale')?.invalid && form.get('codiceFiscale')?.touched"
                                style="color: red;">Errato!</label>
                        </div>
                        <input type="text" class="form-control field-height-40" id="codiceFiscale"
                            formControlName="codiceFiscale" maxlength="20"
                            [ngClass]="{'border-danger': invalidBorder('codiceFiscale') == true}">
                    </div>
                </div>
                <div class="form-group field-14">
                    <label for="etaCompiuta">Età compiuta *</label>
                    <input type="number" class="form-control field-height-40" id="etaCompiuta"
                        formControlName="etaCompiuta" (input)="limitInput($event.target, 3)"
                        [ngClass]="{'border-danger': invalidBorder('etaCompiuta') == true}">
                </div>
            </div>
        </div>
    </div>
</form>